var _a;
import { __decorate, __metadata, __param } from "tslib";
import { RouterService } from '../../../../../cores/services/vue-router-service';
import { DEFAULT_COMMENTS_COUNT_PER_PAGE } from './comments-service.interface';
import { injectable, inject } from 'inversify';
import _ from 'lodash';
let CommentQueryServiceImp = class CommentQueryServiceImp {
    constructor(_routerService) {
        this._routerService = _routerService;
    }
    get _route() {
        return this._routerService.currentRoute;
    }
    getQuery() {
        const { query } = this._route;
        const result = {
            page: _.toNumber(query.page) || 1,
            pageSize: _.toNumber(query.page_size) || DEFAULT_COMMENTS_COUNT_PER_PAGE,
            scope: (query.range || 'ALL'),
            sort: (query.sort || 'UPDATE_TIME_DESC'),
            type: (query.type || 'ALL'),
            keyword: (query.key_word || ''),
            space: (query.location === 'ALL' ? '' : (query.location || '')),
        };
        return result;
    }
    setQuery(query) {
        const currentQuery = this.getQuery();
        const newQuery = {
            ...currentQuery,
            ...query,
        };
        this._routerService.push({
            query: {
                page: newQuery.page.toString(),
                page_size: newQuery.pageSize.toString(),
                range: newQuery.scope,
                sort: newQuery.sort,
                type: newQuery.type,
                key_word: newQuery.keyword,
                location: newQuery.space,
            },
        });
    }
};
CommentQueryServiceImp = __decorate([
    injectable(),
    __param(0, inject(RouterService)),
    __metadata("design:paramtypes", [typeof (_a = typeof RouterService !== "undefined" && RouterService) === "function" ? _a : Object])
], CommentQueryServiceImp);
export { CommentQueryServiceImp };
